// extracted by mini-css-extract-plugin
export default {"dayCardContainer":"DayCard_dayCardContainer__fgPtt","imgWeather":"DayCard_imgWeather__2KD2e","degree":"DayCard_degree__GNtzm","upTo":"DayCard_upTo__nff1D"};